import { useCallback } from "react"

import { useMMKVBoolean } from "react-native-mmkv"

const TERMS_ACCEPTANCE_KEY = "user.setup.hasAcceptedTerms.v2"

export function useTermsAcceptance(userId: string | undefined) {
  const key = userId ? `${TERMS_ACCEPTANCE_KEY}.${userId}` : TERMS_ACCEPTANCE_KEY
  const [hasAcceptedTerms, setHasAcceptedTerms] = useMMKVBoolean(key)

  const acceptTerms = useCallback(() => {
    setHasAcceptedTerms(true)
  }, [setHasAcceptedTerms])

  const declineTerms = useCallback(() => {
    setHasAcceptedTerms(false)
  }, [setHasAcceptedTerms])

  return {
    hasAcceptedTerms: hasAcceptedTerms ?? false,
    acceptTerms,
    declineTerms,
  }
}
